import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
import { offer } from '../data/offer';
import { CHECKOUT_URL } from '../utils/checkout';
export function PriceSummarySection() {
  return <section id="offerta" className="scroll-mt-16 bg-brand-night px-4 py-20 text-white md:py-24" data-id="element-147" data-mp="381a6biy1bos3">
      <Reveal className="mx-auto max-w-2xl" data-id="element-148" data-mp="2kbpmyyxyypia">
        <h2 className="text-center text-3xl font-extrabold md:text-4xl" data-id="element-149" data-mp="2kchjcbze4r9m">Tutto ciò che include il tuo acquisto</h2>

        <ul className="mt-10 space-y-3" data-id="element-150" data-mp="2u8uc97n4313b">
          <SummaryRow label={offer.ebookTitle} price={offer.ebookValue} highlighted data-id="element-151" data-mp="2u9vq1jvii1oq" />
          {bonuses.map(({
          title,
          price
        }) => <SummaryRow key={title} label={`Bonus: ${title}`} price={price} data-id="element-152" data-mp="2pbu6yyy362d9" />)}
          <SummaryRow label="Garanzia di 30 giorni" price="Inclusa" data-id="element-153" data-mp="9gs8fxi8g4o2" />
        </ul>

        <div className="mt-10 rounded-3xl border border-white/15 bg-white/[0.06] p-7 text-center" data-id="element-154" data-mp="4j0fd05uqcia">
          <p className="text-sm font-semibold text-white/70" data-id="element-155" data-mp="2l2g8n6th7k9h">
            Valore normale totale: <span className="line-through" data-id="element-156" data-mp="2q116izl99rur">{offer.totalValue}</span>
          </p>
          <p className="mt-2 text-xs font-extrabold tracking-[0.16em] text-brand-amber" data-id="element-157" data-mp="2v0w0jc0buxk1">PREZZO DI OGGI</p>
          <p className="mt-1 font-display text-6xl font-extrabold tracking-tight text-white md:text-7xl" data-id="element-158" data-mp="300iexorw6juf">
            {offer.todayPrice}
          </p>
          <CTAButton href={CHECKOUT_URL} className="mt-6 w-full py-4" data-id="element-159" data-mp="22adqts53lxxn">
            Acquista adesso con pagamento unico
          </CTAButton>
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-brand-amber/15 px-4 py-1.5 text-[11px] font-extrabold tracking-wide text-brand-amber" data-id="element-160" data-mp="2caea5e2ywe1u">
            Risparmi {offer.saving} ({offer.discount} DI SCONTO)
          </p>
          <p className="mt-4 flex items-center justify-center gap-2 text-[11px] font-semibold text-white/60" data-id="element-161" data-mp="1jlqld8j0f6jj">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-162" data-mp="1oiz35808x8k9" />
            Pagamento unico, nessun abbonamento
          </p>
        </div>
      </Reveal>
    </section>;
}
function SummaryRow({
  label,
  price,
  highlighted = false
}: {
  label: string;
  price: string;
  highlighted?: boolean;
}) {
  return <li className={`flex items-start justify-between gap-4 rounded-2xl px-5 py-4 ${highlighted ? 'bg-white/10' : 'bg-white/[0.04]'}`} data-id="element-163" data-mp="1qc1izulbvkwg">
      <span className="flex min-w-0 items-start gap-3" data-id="element-164" data-mp="xmb77s764v3i">
        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-amber" strokeWidth={3} aria-hidden="true" data-id="element-165" data-mp="smornc3vb2rj" />
        <span className={`text-sm leading-snug ${highlighted ? 'font-bold' : 'font-medium text-white/85'}`} data-id="element-166" data-mp="17k8tia5gwhth">
          {label}
        </span>
      </span>
      <span className="shrink-0 text-sm font-bold text-white/60" data-id="element-167" data-mp="12mpeh80y410h">{price}</span>
    </li>;
}